/** A workflow run's page in the Build area. */
export const flowRunPath = (flowUuid: string, runUuid: string) => `/build/workflows/${flowUuid}/runs/${runUuid}`;

/** A workflow opened from a space (MHS-1011): its runs, kept under the space. */
export const spaceWorkflowPath = (spaceUuid: string, flowUuid: string) => `/spaces/${spaceUuid}/workflows/${flowUuid}`;

/** One run of a workflow opened from a space. */
export const spaceWorkflowRunPath = (spaceUuid: string, flowUuid: string, runUuid: string) =>
  `${spaceWorkflowPath(spaceUuid, flowUuid)}/runs/${runUuid}`;
